import script from "./Shipments.vue?vue&type=script&setup=true&lang=js"
export * from "./Shipments.vue?vue&type=script&setup=true&lang=js"

import "./Shipments.vue?vue&type=style&index=0&id=5ce35a3d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce35a3d"]])

export default __exports__